import { IBoltSubscriptionRequest, IBoltSubscriptionResponse } from '../../../entity/interface/iSubscription';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IBoltUserSubscriptionUseCase {
    execute(payload: IBoltSubscriptionRequest, apiToken: { [key: string]: string }): Promise<IBoltSubscriptionResponse>;
}

export class BoltUserSubscriptionUseCase implements IBoltUserSubscriptionUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IBoltSubscriptionRequest,
        apiToken: { [key: string]: string }
    ): Promise<IBoltSubscriptionResponse> {
        return await this.subscriptionRepository.boltUserSubscription(payload, apiToken);
    }
}
